import react, { Component } from 'react';
import Popup from '../common/Popup';
import { DKLabel, DKButton } from "deskera-ui-library";
import FileImporter from '../deals/deal_ui/import';

class FileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileInfo: '',
            files:[]
        }
    }
    isMultiSelect = this.props.isMultiSelect !== undefined ? this.props.isMultiSelect : true;
    onClose() {
        this.props.onClose()
    }
    save() {
        this.props.onSave(this.state.files);
    }
    upload(param) {
        this.state.files.push(param)

        if(this.isMultiSelect) {
            this.setState({
                fileInfo: this.state.files
            })
        } else {
            this.setState({
                fileInfo: param.fileInfo
            })
        }
    }
    render() {
        return (
            <>
                <Popup>
                    <div style={{ height: '60vh' }}>
                        <div className="parent-width" style={{ display: "flex" }}>
                            <DKLabel text={`Add Attachment`} className="fs-m fw-m align-self-center width-80" />
                            <div className="d-flex m-v-s ">
                                <DKButton
                                    title="Cancel"
                                    className="g-gray1 border-m"
                                    onClick={(event) => {
                                        this.onClose();
                                    }}
                                />
                                <DKButton
                                    title="Save"
                                    className="border-m ml-r bg-app text-white border-n"
                                    onClick={() => this.save()}
                                />

                            </div>
                        </div>
                        <div className="parent-width border-box bg-white border-radius-s mt-m">
                            <div className="row justify-content-between">
                                <FileImporter 
                                    acceptFileFormat={[".pdf",".jpeg",".png"]} 
                                    fileInfo={this.state.fileInfo}  
                                    getFile={(param) => this.upload(param)} 
                                    title= "Upload a file you want to submit"
                                    isForPopup={true}
                                    isMultiSelect={this.isMultiSelect}
                                />
                            </div>
                        </div>

                    </div>
                </Popup>
            </>
        )
    }
}
export default FileUpload;